module.exports = __webpack_public_path__ + "static/assets/2e0c4790f8f9cf28e3c346b9cef0fcb6.svg";